// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".socialmediainsert_socialText {\r\n  padding-top: 20px;\r\n  font-size: 1.1vw !important;\r\n}\r\n.socialmediainsert_socialcontainer {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.socialmediainsert_bottomBarLogoFb {\r\n  height: 5vh;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n}\r\n.socialmediainsert_bottomBarLogoIn {\r\n  height: 5vh;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n}", ""]);
// Exports
module.exports = exports;
